import type { TimingTrack, VerseCue } from '@fcbh/audio';
import type { AudioStyle } from '../state/player-settings.js';
import { SAMPLE_CHAPTERS } from './sample-chapter.js';

/**
 * Synthetic timing tracks for demo chapters. Used as a fallback when the
 * Bible Brain API is not reachable (e.g. no VITE_DBP_API_KEY configured),
 * so the karaoke underline still demos against silent audio scrubbing.
 *
 * Verse spans scale to a per-character reading rate — dramatized mode is
 * a touch slower because it includes character beats and music swells.
 */

const CPS_PLAIN = 18;
const CPS_DRAMATIZED = 14;
const MIN_SEC = 2.2;

export function sampleTimingFor(
  book: string,
  chapter: number,
  audioStyle: AudioStyle,
): TimingTrack | null {
  const ch = SAMPLE_CHAPTERS.find(
    (c) => c.bookId === book.toUpperCase() && c.chapter === chapter,
  );
  if (!ch) return null;

  const cps = audioStyle === 'dramatized' ? CPS_DRAMATIZED : CPS_PLAIN;
  const verses: VerseCue[] = [];
  let cursor = 0.4;
  for (const v of ch.verses) {
    const dur = Math.max(MIN_SEC, v.text.length / cps);
    verses.push({
      verseRef: v.ref,
      beginSec: cursor,
      endSec: cursor + dur,
    });
    cursor += dur + 0.2;
  }
  return { source: 'manual', verses };
}
